<template>
  <div>
    <b-form-checkbox v-model="invoiceRequired">
      <p v-if=short>Rechnung benötigt</p>
      <p v-else>
        An unserer Schule zahlen nicht die Eltern sondern es übernimmt die Schule/der Förderverein/ein privater Sponsor
        o.ä. die Kosten für die Wettbewerbsteilnahme. Deshalb benötigen wir eine Rechnung. Die Rechnung geht bitte an
        die folgende Rechnungsadresse (falls von der Schuladresse abweichend).
      </p>
    </b-form-checkbox>

    <b-collapse :visible=invoiceRequired id="invoice">
      <b-form-group label-for="invoice" label="Rechnungsempfänger:" class="m-3" display="none">
        <textarea type="text" v-model="invoiceAddress" class="w-50" rows="4"></textarea>
      </b-form-group>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'Invoice',
  props: {
    required: Boolean,
    address: String,
    short: Boolean
  },

  data: function () {
    return {
      invoiceRequired: false,
      invoiceAddress: ''
    }
  },

  mounted: function () {
    this.invoiceRequired = this.required
    this.invoiceAddress = this.address
  },

  watch: {
    'invoiceRequired': function (value, prev) {
      if (value !== prev) {
        this.$emit('invoiceRequired', value)
      }
    },

    'invoiceAddress': function (value, prev) {
      if (value !== prev) {
        this.$emit('invoiceAddress', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/Invoice.vue